<template>
    <div class="imgBox min-w-1400">
      <div class="imgBox1 min-w-1400">
        <div class="img1 max-w-1400">
          <p class="imgItem1">Bảo mật thông tin</p>
          <!-- <img :src="importedImg1" :alt="altText" class="imgItem1" /> -->
        </div>
      </div>
      <div class="imgBox2 min-w-1400">
        <div class="img2 max-w-1400">
          <!-- <h1>Cam kết bảo mật</h1> -->
          <!-- <div class="title-line"></div> -->
          <div class="textBox" style="white-space: pre-wrap">{{ text }}</div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  // import importedImg1 from "@/page/passmorecompany/components/img/4_1.png";
  
  export default {
    data() {
      return {
        altText: "protocolTitle",
        // importedImg1: importedImg1,
        text: `1. Mục đích và phạm vi thu thập

Dữ liệu chính được thu thập bởi trang web của công ty bao gồm: họ tên đầy đủ của khách hàng, email, điện thoại, địa chỉ trong phần liên hệ. Đây là thông tin mà công ty cần khách hàng cung cấp bắt buộc khi gửi thông tin tư vấn hoặc muốn mua sản phẩm, để công ty liên hệ, xác nhận với khách hàng trên website nhằm đảm bảo quyền lợi sử dụng của người tiêu dùng.

Khách hàng sẽ chịu toàn bộ trách nhiệm về tính bảo mật và lưu trữ thông tin mình cung cấp cũng như mọi hoạt động sử dụng dịch vụ dưới địa chỉ email của mình. Ngoài ra, Khách hàng có trách nhiệm thông báo kịp thời cho trang web của Công ty về bất kỳ hành vi sử dụng trái phép, sử dụng sai mục đích, vi phạm bảo mật hoặc bên thứ ba nắm giữ tên đã đăng ký và mật khẩu để có thể thực hiện hành động và giải pháp phù hợp.

2. Phạm vi sử dụng thông tin:

Công ty sử dụng thông tin khách hàng để:

Sau khi nhận được yêu cầu của khách hàng, liên hệ để xác nhận đơn hàng và vận chuyển hàng đến tay khách hàng;

Cung cấp thông tin sản phẩm cho khách hàng theo nhu cầu của họ;

Gửi email tiếp thị và quảng cáo về các sản phẩm chúng tôi bán;

Gửi thông báo về sự kiện quyên góp trên trang web của công ty;

Liên hệ và xử lý người dùng trong những tình huống đặc biệt;

Thông tin cá nhân của người dùng sẽ không được sử dụng cho bất kỳ mục đích nào khác ngoài mục đích xác nhận và liên hệ liên quan đến các giao dịch của công ty;

Theo yêu cầu của các cơ quan tư pháp bao gồm: Viện kiểm sát, tòa án, cơ quan cảnh sát điều tra,... liên quan đến một số hành vi vi phạm pháp luật của khách hàng.

3. Thời gian lưu giữ thông tin:

Thông tin cá nhân của khách hàng sẽ được lưu trữ cho đến khi người quản trị yêu cầu hủy. Trong mọi trường hợp, thông tin cá nhân của khách hàng sẽ được bảo mật trên máy chủ của công ty.

4. Các cách thức và công cụ để người dùng truy cập và chỉnh sửa thông tin cá nhân của mình.

Khách hàng có quyền xem xét, cập nhật, điều chỉnh hoặc hủy bỏ thông tin cá nhân của mình bằng cách liên hệ với quản trị viên trang web của công ty.

Khách hàng có quyền nộp khiếu nại liên quan đến việc tiết lộ thông tin cá nhân với ban quản lý trang web của chúng tôi. Sau khi nhận được những phản hồi này, công ty sẽ xác nhận lại thông tin. Nếu phản hồi của khách hàng là chính xác, công ty sẽ có hành động kịp thời tùy theo hoàn cảnh.

5. Cam kết bảo vệ thông tin cá nhân của khách hàng

Công ty cam kết sẽ bảo mật tuyệt đối thông tin cá nhân của khách hàng theo chính sách bảo vệ thông tin cá nhân. Trừ khi pháp luật có quy định khác, Công ty sẽ chỉ thu thập và sử dụng thông tin của mỗi khách hàng khi có sự đồng ý của khách hàng.

Thông tin cá nhân của khách hàng sẽ không được sử dụng, chuyển giao, cung cấp hoặc tiết lộ cho bất kỳ bên thứ ba nào mà không có sự đồng ý của khách hàng.

Trong trường hợp máy chủ thông tin bị tin tặc tấn công và dữ liệu cá nhân của khách hàng bị mất, công ty sẽ có trách nhiệm báo cáo sự việc cho bộ phận điều tra xử lý kịp thời và thông báo cho khách hàng. Sản phẩm đã được biết đến.

Ban quản lý công ty yêu cầu cá nhân khi đăng ký/mua hàng phải cung cấp đầy đủ thông tin cá nhân có liên quan như: Họ và tên, địa chỉ liên lạc, email, điện thoại, ..., và chịu trách nhiệm về tính hợp pháp của những thông tin trên. Nếu Ban quản lý Công ty cho rằng mọi thông tin cá nhân do khách hàng cung cấp trong quá trình đăng ký ban đầu là không chính xác, Ban quản lý Công ty sẽ không chịu trách nhiệm và sẽ không giải quyết bất kỳ khiếu nại nào liên quan đến quyền lợi của khách hàng đó. Xác chết.

6. Địa chỉ của tổ chức thu thập và quản lý thông tin cá nhân

CÔNG TY TNHH THƯƠNG MAI DICH VŨ

Địa chỉ: D17/42 Ấp 4P, Xã Hưng Long, Huyện Bình Chánh, Thành phố Hồ Chí Minh
ĐT: 0901234567`,
      };
    },
    created() {
    this.gotoTop();
  },
  methods: {
    gotoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
  };
  </script>
  
  <style scoped>
  .imgBox {
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
  }
  
  .imgBox1 {
    display: flex;
    justify-content: center;
    width: 100%;
    min-width: 1400px;
    background-color: "";
  }
  
  .imgBox2 {
    display: flex;
    justify-content: center;
    max-width: 1400px;
    padding-top: 40px;
    padding-bottom: 20px;
    height: 3700px;
    background-color: #ffffff;
    border-radius: 32px;
    margin: -140px auto 150px;
  }
  
  .imgBox3 {
    display: flex;
    justify-content: center;
    width: 100%;
    min-width: 1400px;
    background-color: "";
  }
  
  img {
    display: block;
  }
  
  .img1 {
    overflow: hidden;
    width: 100%;
  }
  
  .img2,
  .img4 {
    overflow: hidden;
  }
  
  .img3 {
    width: 100%;
    overflow: hidden;
    margin-left: 0;
    margin-right: 0;
  }
  
  .imgItem1 {
    width: 100%;
    margin-top: 0;
    margin-bottom: 0;
  }
  
  .imgItem2 {
    max-width: 100%;
  }
  
  .imgItem3 {
    width: 100%;
    overflow: hidden;
    margin-left: 0;
    margin-right: 0;
  }
  
  h1 {
    margin-top: 50px;
    margin-left: 490px;
    color: #3f4842;
    font-size: 40px;
    /* border-bottom: 5px solid #04358A; */
    display: inline-block;
  }
  
  .textBox {
    margin-top: 50px;
    margin-left: 100px;
    margin-right: 100px;
    font-size: 18px;
    color: #333333;
  }
  
  .imgBox2 {
    transform: scale(90%);
    /* transform: scale(80%); */
    margin: -150px auto 100px;
    height: 1800px;
    /* box-shadow: 0 1px 4.8px 0px rgba(246, 102, 11, 0.25); */
    /* border: 2px solid #F6660B; */
  }
  .textBox {
    margin-top: 20px;
    margin-left: 50px;
    margin-right: 50px;
  }
  /* .imgBox2{
    border-radius: 0;
    border-top: 3px solid #7c2af8;
    border-left: 2px solid #e9e9e9;
    border-right: 2px solid #e9e9e9;
    border-bottom: 3px solid #c1c1c1;
  } */
  .title-line {
    width: 430px;
    /* background: url(./components/img/Group1.png); */
    /* background-repeat: no-repeat; */
    /* background-position: -150px 10px; */
    /* height: 50px; */
    /* border: 1px solid red; */
    border: 5px solid #0baf60;
    margin: 0 500px;
  }
  
  .img1 {
    /* background: radial-gradient(57.03% 57.03% at 50% 50%, #3C51A0 0%, #223479 100%); */
    height: 291px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .imgItem1 {
    color: #333333;
    font-family: "SF Pro Display";
    font-weight: 700;
    font-size: 52px;
    text-align: center;
  }
  </style>
  